<template>
  <div class="content-area">
    <hero-bar>
      Servis Talepleri
      <b-tooltip slot="right" :label="$t('refresh')" type="is-dark" position="is-bottom">
        <b-button
          id="refresh-button"
          class="mr-10"
          size="is-circle"
          type="is-link"
          outlined
          :class="{ 'is-loading': refreshLoading }"
          icon-left="refresh"
          @click="refresh"
        />
      </b-tooltip>
      <b-tooltip slot="right" :label="$t('exportExcel')" type="is-dark" position="is-bottom">
        <b-button
          id="excelButton"
          class="mr-10 is-hidden-mobile"
          size="is-circle"
          type="is-link"
          outlined
          :class="{ 'is-loading': excelLoading }"
          icon-left="file-excel"
          @click="$refs.serviceRecordsTable.exportExcel(); excelLoading = true;"
        />
      </b-tooltip>
      <b-button
        v-if="checkPermission('create_transfer')"
        id="new-request"
        slot="right"
        tag="router-link"
        :to="{ name: 'service_records.create'}"
        icon-left="plus-circle"
        type="is-link"
      >
        {{ $t('createServiceRecord') }}
      </b-button>
    </hero-bar>

    <section class="section is-main-section">
      <card-component class="has-table has-mobile-sort-spaced">
        <service-records-table
          id="serviceRecordsTable"
          ref="serviceRecordsTable"
          data-url="/service-records"
          @excelChange="actionExcelChange"
          @loadingChange="actionLoadingChange"
        />
      </card-component>
    </section>
  </div>
</template>

<script>
export default {
  title: 'Servis Talepleri',
  components: {
    HeroBar: () => import('@/components/HeroBar'),
    CardComponent: () => import('@/components/CardComponent'),
    ServiceRecordsTable: () => import('@/components/ServiceRecordsTable'),
  },
  data () {
    return {
      excelLoading: false,
      refreshLoading: false,
    }
  },
  methods: {
    refresh () {
      document.getElementById('refresh-button').blur()
      this.refreshLoading = true
      this.$refs.serviceRecordsTable.loadTransfers()
    },
    actionExcelChange (e) {
      setTimeout(() => {
        this.excelLoading = e
      }, 500)
    },
    actionLoadingChange (e) {
      this.refreshLoading = e
    }
  },
}
</script>
